import { TokenSymbol, TokenSymbolSchema } from "./trading-types";
import { DecimalSchema } from "../decimal";
import z from "zod";

// Transaction types
export type TxType = "transfer" | "swap" | "deposit" | "withdrawal" | "order";

export enum TxStatus {
  PENDING = "pending",
  OK = "ok",
  CANCELLED = "cancelled",
  FAILED = "failed",
}

export const FeeSchema = z.object({
  amount: z.number(), // amount (not percentage) of crypto taken as fee
  refAmount: z.number().optional(),
  tokenSymbol: TokenSymbolSchema, // crypto token involved in the taken fee
});

export type Fee = z.infer<typeof FeeSchema>;

export const FeeV2Schema = z.object({
  amount: DecimalSchema,
  tokenSymbol: TokenSymbolSchema,
  refAmount: DecimalSchema.optional(),
});

export type FeeV2 = z.infer<typeof FeeV2Schema>;

export type FeeWithAmounts = {
  feeAmount: number;
  feeTokenSymbol: TokenSymbol;
  baseAmount: number; // amount of crypto after charging the fee
  quoteAmount: number; // amount of crypto after charging the fee
};
